import type { ReactNode } from 'react';

export const symbol_9k: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M383-410h-95q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h112q14.02 0 23.51-9.49Q433-378.98 433-393v-173q0-14.45-9.49-24.22Q414.02-600 400-600H296q-14.02 0-23.51 9.78Q263-580.45 263-566v70q0 14.02 9.49 23.51Q281.98-463 296-463h87v53Zm-70-86v-71h70v71h-70Zm257 46 77 82q2 2 17 8 16 0 22.5-15t-4.5-26l-74-79 74-80q11-11 4.5-25.5T664-600q-4.79 0-8.89 2-4.11 2-8.11 6l-77 82v-65q0-10.83-7.12-17.92-7.11-7.08-18-7.08-10.88 0-17.88 7.08-7 7.09-7 17.92v190q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-65ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
